
export let defaultPhoneCode = function () {
    let alliance = !!vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
    let user = !!vue_data && vue_data.hasOwnProperty('user') ? vue_data.user : null;
    let partner = !!user && user.hasOwnProperty('partner') ? user.partner : null;

    if(partner && partner.hasOwnProperty('default_phone_code')) {
        return partner.default_phone_code;
    }
    else if(alliance && alliance.hasOwnProperty('default_phone_code')) {
        return alliance.default_phone_code;
    }
    else {
        let parent_type = !!vue_data && !!vue_data.application && !!vue_data.application.parent_type ? vue_data.application.parent_type : '';
        let tenantData = !!parent_type && vue_data[parent_type.toLowerCase()] ? vue_data[parent_type.toLowerCase()] : {};
        return !!tenantData && tenantData.hasOwnProperty('default_phone_code') && tenantData.default_phone_code !== '' ? tenantData.default_phone_code : 'GB|44';
    }
}();

export let defaultCountry = function () {

    let alliance = !!vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
    let user = !!vue_data && vue_data.hasOwnProperty('user') ? vue_data.user : null;
    let partner = !!user && user.hasOwnProperty('partner') ? user.partner : null;

    if(partner && partner.hasOwnProperty('contact_country')) {
        return partner.contact_country;
    }
    else if(alliance && alliance.hasOwnProperty('contact_country')) {
        return alliance.contact_country;
    }
    else {
        let parent_type = !!vue_data && !!vue_data.application && !!vue_data.application.parent_type ? vue_data.application.parent_type : '';
        let tenantData = !!parent_type && vue_data[parent_type.toLowerCase()] ? vue_data[parent_type.toLowerCase()] : {};
        return !!tenantData && tenantData.hasOwnProperty('contact_country') ? tenantData.contact_country : '826';
    }
}();

export let defaultCurrency = function () {
    let alliance = !!vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
    let user = !!vue_data && vue_data.hasOwnProperty('user') ? vue_data.user : null;
    let partner = !!user && user.hasOwnProperty('partner') ? user.partner : null;

    if(partner && partner.hasOwnProperty('default_currency')) {
        return partner.default_currency;
    }
    else if (alliance && alliance.hasOwnProperty('default_currency')) {
        return alliance.default_currency;
    }
    else {
        return 'GBP';
    }
}();


export let allianceCode = function () {
    let alliance = !!vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null;
    let user = !!vue_data && vue_data.hasOwnProperty('user') ? vue_data.user : null;

    if (alliance) {
        return alliance.alliance_code;
    } else if (user) {
        alliance = user.hasOwnProperty('alliance') ? user.alliance : '';

        return !!alliance ? alliance.alliance_code : '';
    }

    return '';
}();

export let checkConfig = function(check_type=null, config=null, template_name=null, block_name=null, element_name=null){
    //console.log('Independent checkConfig')
    let checks = ['IS_REQUIRED', 'IS_SELECTED']

    const check = (attribute) => {
        if(check_type === 'IS_REQUIRED')
        {
            return attribute.is_required === 'Y'
        }
        else if(check_type === 'IS_SELECTED'){
            return attribute.selected === 'Y'
        }
        return false
    }

    if(check_type && checks.find(e => e === check_type)) {
        let template = config && template_name ? config[template_name] : null
        let blocks = template && template.hasOwnProperty('blocks') ? template['blocks'] : null
        let block = blocks && blocks.hasOwnProperty(block_name) ? blocks[block_name] : null
        let elements = block && block.hasOwnProperty('elements') ? block['elements'] : null
        let element = elements && element_name ? elements[element_name] : null

        if (element && element.hasOwnProperty('attribute')) {
            return check(element.attribute)
        } else if (block && element.hasOwnProperty('attribute')) {
            return check(block.attribute)
        }
    }

    return false

};

export let self_boarding_page_config = function(){
    //console.log('cross check')
    let alliance = vue_data && vue_data.hasOwnProperty('alliance') ? vue_data.alliance : null
    let parameters = vue_data && vue_data.hasOwnProperty('parameters') ? vue_data.parameters : null
    let user = !!vue_data && vue_data.hasOwnProperty('user') ? vue_data.user : null;
    let partner = !!user && user.hasOwnProperty('partner') ? user.partner : null;

    alliance = !alliance && this && this.alliance ? this.alliance : alliance
    parameters = !parameters && this && this.parameters ? this.parameters : parameters

    //console.log('self_boarding_page_config', alliance, parameters)

    let merchant_hierarchy_configs = parameters && parameters['MERCHANT_HIERARCHY_CONFIGURATION'] ? parameters['MERCHANT_HIERARCHY_CONFIGURATION'] : null
    let merchant_hierarchy_config = null;

    if (partner && merchant_hierarchy_configs) {
        merchant_hierarchy_config = merchant_hierarchy_configs.find(config => config.partner_external_id === partner.partner_external_id);
    }
    else if (alliance && merchant_hierarchy_configs) {
        merchant_hierarchy_config = merchant_hierarchy_configs.find(config => config.alliance_external_id === alliance.alliance_external_id);
    }

    let template = merchant_hierarchy_config && merchant_hierarchy_config.templates ? merchant_hierarchy_config.templates.find(config => config.entity_type === 'SELFBOARDING') : null

    let page_config_external_id =  template && template.page_config_external_id ? template.page_config_external_id : null

    let page_config_combination = parameters && parameters['PAGE_CONFIGURATION_COMBINATION'] ? parameters['PAGE_CONFIGURATION_COMBINATION'] : null
    let page_config = page_config_external_id && page_config_combination && page_config_combination.hasOwnProperty(page_config_external_id) ? page_config_combination[page_config_external_id] : []

    //console.log('page_config_external_id', page_config_external_id, page_config_combination, page_config)

    return page_config
}();

export let defaultMarketingOptIn = function () {

    //default value based on config
    //console.log('default value')
    let template_name = 'SelfBusinessCriteria';
    let config = self_boarding_page_config && self_boarding_page_config.hasOwnProperty(template_name) ? self_boarding_page_config[template_name] : null
    let block = 'block_application_options'
    let element = 'marketing_opt_in'

    if(config)
    {
        let response = checkConfig('IS_SELECTED', self_boarding_page_config, template_name, block, element)

        if(response){
            //console.log('uncheck default opt in')
            return '0'; //opt in unchecked value is 0
        }

        element = 'marketing_opt_out'
        response = checkConfig('IS_SELECTED', self_boarding_page_config, template_name, block, element)

        if(response){
            //console.log('uncheck default opt out')
            return '1'; //opt out unchecked value is 1
        }
    }

    return '0';

}();
